import React from 'react';

function ProcessingModal({ visible }) {
  return (
    <div className={`processing ${visible ? 'visible' : ''}`} id="processing">
      <div className="modal-content">
        <div className="spinner"></div>
        <p>Finding the perfect movie...</p>
      </div>
    </div>
  );
}

export default ProcessingModal;
